export const environment = {
  production: false,
  scheme: "https://",
  host: "api-managment-digitalizcija.azure-api.net/vrc-api-test",
  auth_host: "api-managment-digitalizcija.azure-api.net/vrc-api-test",
  crm_host: "api-managment-digitalizcija.azure-api.net/vrc-api-test",
  offer_host: "api-managment-digitalizcija.azure-api.net/vrc-api-test",
  validation_host: "api-managment-digitalizcija.azure-api.net/vrc-api-test",
  port: "",
  version: 1,
  authVersion: 1,
  crmVersion: 1,
  offerVersion: 1,
  validationVersion: 1,
  app_url: 'https://vrc.test.valamar.hr',
  web_url: 'https://www.valamar-preview.com',
  enableServiceWorker: true,
  theme: "theme-background-test",
  env_text: "Test",
  msalConfig: {
    auth: {
      clientId: "9b3d1ecc-486b-433f-b441-e5cfd04eca7b",
      authority: "https://login.microsoftonline.com/c7223f2c-1ba2-43c8-be7f-57e6e1465036"
    },
    api:"d219d9a0-d02b-4768-8d83-b5cd419288d2/All.All"
  }
};
